import { List } from '../List'
import { CommonWork } from '../CommonWork'

export class EducationalPublicationParent extends List {
  constructor(obj) {
    super(EducationalPublication, obj)
  }
}

export class EducationalPublication {
  constructor(obj) {
    this.id = obj?.id || null
    this.commonWork = new CommonWork(obj?.commonWork || null)
    this.educationalPublicationType = obj?.educationalPublicationType || null
    this.publishingPlace = obj?.publishingPlace || null
    this.publishingHouse = obj?.publishingHouse || null
    this.publishingHouseStr = obj?.publishingHouseStr || null
    this.isNoPublishingHouse = obj?.isNoPublishingHouse || Boolean(obj?.publishingHouseStr) || false
    this.publicationNumber = obj?.publicationNumber || null
    this.pageCount = obj?.pageCount || null
    this.publicationForm = obj?.publicationForm || null
    this.isbn = obj?.isbn || null
    this.edition = obj?.edition || null
    this.highSchool = obj?.highSchool || null
    this.highSchoolStr = obj?.highSchoolStr || null
    this.isNoHighSchool = obj?.isNoHighSchool || Boolean(obj?.highSchoolStr) || false
    this.isForeign = obj?.isForeign || false
    this.link = obj?.link || null
  }

  get fullBibliographicDescription() {
    if (!this?.commonWork?.authors?.list.length) return ''

    const names = []
    const namesReverse = []
    for (const author of this.commonWork.authors.list) {
      if (author.employee) {
        names.push(
          `${author.employee.lastName}, ${author.employee.firstName?.[0]}. ${author.employee.middleName?.[0]}.`
        )
        namesReverse.push(
          `${author.employee.firstName?.[0]}. ${author.employee.middleName?.[0]}. ${author.employee.lastName}`
        )
      }

      if (author.nameRus) {
        const splitName = author.nameRus?.split(' ')
        if (splitName?.length !== 3) return ''
        names.push(`${splitName[0]}, ${splitName[1]?.[0]}. ${splitName[2]?.[0]}.`)
        namesReverse.push(`${splitName[1]?.[0]}. ${splitName[2]?.[0]}. ${splitName[0]}`)
      }

      if (author.firstNameEng && author.lastNameEng && author.middleNameEng) {
        names.push(`${author.lastNameEng}, ${author.firstNameEng[0]}. ${author.middleNameEng[0]}.`)
        namesReverse.push(`${author.firstNameEng[0]}. ${author.middleNameEng[0]}. ${author.lastNameEng}`)
      }
    }

    return names.length &&
      namesReverse.length &&
      this.commonWork.workName &&
      this.educationalPublicationType?.name &&
      (this.isNoHighSchool ? this.highSchoolStr : this.highSchool?.name?.trim()) &&
      this.publishingPlace &&
      (this.isNoPublishingHouse ? this.publishingHouseStr : this.publishingHouse?.name) &&
      this.commonWork.year?.year &&
      this.pageCount
      ? names.join(',') +
          ' ' +
          this.commonWork.workName +
          ' : ' +
          this.educationalPublicationType?.name +
          ' / ' +
          namesReverse.join(',') +
          ' ; ' +
          (this.isNoHighSchool ? this.highSchoolStr : this.highSchool?.name?.trim()) +
          ' - ' +
          this.publishingPlace +
          ' : ' +
          (this.isNoPublishingHouse ? this.publishingHouseStr : this.publishingHouse?.name) +
          ', ' +
          this.commonWork.year?.year +
          '.- ' +
          this.pageCount +
          'c.' +
          `${this.isbn ? '- ISBN ' + this.isbn : ''}`
      : ''
  }

  getForAPI() {
    return {
      id: this.id,
      commonWork: this.commonWork.getForAPI(),
      educationalPublicationType: this.educationalPublicationType,
      publishingPlace: this.publishingPlace,
      publishingHouse: this.publishingHouse,
      publishingHouseStr: this.publishingHouseStr,
      isNoPublishingHouse: this.isNoPublishingHouse,
      publicationNumber: this.publicationNumber,
      pageCount: this.pageCount,
      publicationForm: this.publicationForm,
      fullBibliographicDescription: this.fullBibliographicDescription,
      isbn: this.isbn,
      edition: this.edition,
      isNoHighSchool: this.isNoHighSchool,
      highSchool: this.highSchool,
      highSchoolStr: this.highSchoolStr,
      isForeign: this.isForeign,
      link: this.link
    }
  }
}
